export const MenuList = [
    {
        title: "लॉगिन",
        url: "/"
    },
]